// BarnAppSplash — the branded launch/boot screen for a barn app. Shown while the
// BarnAppShell chunk + first data load. Fully self-contained (inline styles + an
// SVG spinner) so it renders correctly BEFORE BarnApp.css is loaded (that CSS
// ships in the lazy shell chunk this splash is the fallback for). The barn's logo
// (cream reverse art) sits on the brand's dark color, like a native launch image.

import { activeBarnApp } from "./registry";

export default function BarnAppSplash() {
  const cfg = activeBarnApp();
  const c = cfg?.brand.colors;
  // A light-masthead barn boots on white with its dark logo, so the launch
  // screen matches the home screen it hands over to (mastheadTone: "light").
  const light = cfg?.brand.mastheadTone === "light";
  const bg = light ? "#FFFFFF" : (c?.primaryDark ?? c?.primary ?? "#0E2C36");
  const logo = light
    ? (cfg?.brand.logoSrc ?? cfg?.brand.logoReverseSrc ?? "")
    : (cfg?.brand.logoReverseSrc ?? cfg?.brand.logoSrc ?? "");
  const fg = light ? (c?.ink ?? "#17232A") : "#fff";
  const ring = light ? "rgba(23,35,42,0.15)" : "rgba(255,255,255,0.18)";
  const arc = light ? (c?.ink ?? "#17232A") : "rgba(255,255,255,0.9)";

  return (
    <div style={{ position: "fixed", inset: 0, background: bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 30, padding: 24 }}>
      {logo ? (
        <img src={logo} alt={cfg?.brand.displayName ?? ""} style={{ height: 104, maxWidth: "66%", objectFit: "contain" }}
          onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = "none"; }} />
      ) : (
        <div style={{ color: fg, fontSize: 22, fontWeight: 800, letterSpacing: "-.01em", textAlign: "center" }}>{cfg?.brand.displayName ?? "RaisedBeef"}</div>
      )}
      <svg width="34" height="34" viewBox="0 0 34 34" aria-hidden="true">
        <circle cx="17" cy="17" r="14" fill="none" stroke={ring} strokeWidth="3" />
        <circle cx="17" cy="17" r="14" fill="none" stroke={arc} strokeWidth="3" strokeLinecap="round" strokeDasharray="24 64">
          <animateTransform attributeName="transform" type="rotate" from="0 17 17" to="360 17 17" dur="0.9s" repeatCount="indefinite" />
        </circle>
      </svg>
    </div>
  );
}
